var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _dec4, _class2, _descriptor3, _descriptor4, _dec5, _dec6, _dec7, _class3, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import ModelTraits from "../ModelTraits";
export let ItemPropertiesByTypeTraits = (_dec = primitiveTrait({
  name: "Type of model",
  description: "The type of model to apply `itemProperties` to. This must be defined.",
  type: "string"
}), _dec2 = anyTrait({
  name: "Item Properties",
  description: "Sets traits on group member items of specified `type`. This applies to all nested group members (eg members in sub-groups)"
}), _class = class ItemPropertiesByTypeTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "type", _descriptor, this);
    _initializerDefineProperty(this, "itemProperties", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "itemProperties", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export let ItemPropertiesByIdTraits = (_dec3 = primitiveArrayTrait({
  name: "IDs of models",
  description: "The IDs of models to apply `itemProperties` to.",
  type: "string"
}), _dec4 = anyTrait({
  name: "Item Properties",
  description: "Sets traits on group member items of specified `id`. This applies to all nested group members (eg members in sub-groups)"
}), _class2 = class ItemPropertiesByIdTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "ids", _descriptor3, this);
    _initializerDefineProperty(this, "itemProperties", _descriptor4, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "ids", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "itemProperties", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export let ItemPropertiesTraits = (_dec5 = anyTrait({
  name: "Item Properties",
  description: "Sets traits on group member items (note - will **not** set traits to sub-groups). This applies to all nested group members (eg members in sub-groups). Also see `itemPropertiesByType` and `itemPropertiesByIds`.\n\n" + "Item properties will be set in the following order (highest to lowest priority) `itemPropertiesByIds`, `itemPropertiesByType`, `itemProperties`."
}), _dec6 = objectArrayTrait({
  name: "Item properties by type",
  description: "Sets traits on group member items by model `type` (eg `csv` or `geojson`). This applies to all nested group members (eg members in sub-groups). Only one `itemProperties` can be specified per `type`.\n\n" + "Item properties will be set in the following order (highest to lowest priority) `itemPropertiesByIds`, `itemPropertiesByType`, `itemProperties`.",
  type: ItemPropertiesByTypeTraits,
  idProperty: "type"
}), _dec7 = objectArrayTrait({
  name: "Item properties by type",
  description: "Sets traits on group member items by model `ID`. This applies to all nested group members (eg members in sub-groups). Only one `itemProperties` can be specified per `id`.\n\n" + "Item properties will be set in the following order (highest to lowest priority) `itemPropertiesByIds`, `itemPropertiesByType`, `itemProperties`.",
  type: ItemPropertiesByIdTraits,
  idProperty: "index"
}), _class3 = class ItemPropertiesTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "itemProperties", _descriptor5, this);
    _initializerDefineProperty(this, "itemPropertiesByType", _descriptor6, this);
    _initializerDefineProperty(this, "itemPropertiesByIds", _descriptor7, this);
  }
}, _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, "itemProperties", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, "itemPropertiesByType", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, "itemPropertiesByIds", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _class3);